/**
 * @generated SignedSource<<e1c34687c3ee7189ce53826a3d6b9107>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PushNotificationsCardFragment_notificationSubscriptions$data = {
  readonly surveyInviteContactChannels: ReadonlyArray<string> | null;
  readonly " $fragmentType": "PushNotificationsCardFragment_notificationSubscriptions";
};
export type PushNotificationsCardFragment_notificationSubscriptions$key = {
  readonly " $data"?: PushNotificationsCardFragment_notificationSubscriptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"PushNotificationsCardFragment_notificationSubscriptions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PushNotificationsCardFragment_notificationSubscriptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyInviteContactChannels",
      "storageKey": null
    }
  ],
  "type": "NotificationSubscriptions",
  "abstractKey": null
};

(node as any).hash = "29df2329ad916d895d24c0e53cf8dc38";

export default node;
